import React from "react";
import Button from "../canon/Button";

function cx(...classes) {
  return classes.filter(Boolean).join(" ");
}

/**
 * HeroBannerTemplate
 * - Prominent promotional/feature banner for category pages.
 */
export function HeroBannerTemplate({
  title = "",
  blurb = "",
  ctaHref = "#",
  ctaLabel = "Learn more",
  variant = "brand", // 'brand' | 'neutral'
  className = "",
  contentClassName = "",
  icon: IconComponent = null, // Optional React component for background icon
}) {
  const isBrand = variant === "brand";
  const containerTokens = cx(
    "rounded-2xl overflow-hidden shadow-succession-lg border border-succession-border h-full",
    isBrand ? "bg-succession-secondary" : "bg-succession-bg-primary",
    IconComponent ? "relative group" : ""
  );
  const textWrapper = isBrand ? "text-white" : "text-succession-text-primary";
  const blurbText = isBrand ? "text-white/85" : "text-succession-text-secondary";

  return (
    <div className={cx(containerTokens, className)}>
      {/* Background Icon */}
      {IconComponent && (
        <div className="absolute -right-6 -bottom-6 opacity-10 group-hover:opacity-15 transition-opacity">
          <IconComponent className={cx("w-32 h-32", isBrand ? "text-white" : "text-succession-text-primary")} strokeWidth={1.5} />
        </div>
      )}
      <div className={cx("px-4 py-3 md:px-6 md:py-5 lg:px-8 lg:py-6 h-full flex flex-col justify-center", contentClassName, IconComponent ? "relative z-10" : "")}>
        <div className={textWrapper}>
          {title ? (
            <h2 className="m-0 p-0 text-2xl md:text-3xl font-bold">{title}</h2>
          ) : null}
          {blurb ? (
            <p className={cx("mt-3 text-base md:text-lg leading-relaxed max-w-prose", blurbText)}>
              {blurb}
            </p>
          ) : null}
          {ctaLabel ? (
            <div className="mt-5">
              <Button as="a" href={ctaHref} className="rounded-full">
                {ctaLabel}
              </Button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}


